import React, { useEffect, useState } from "react";
import "../CompanyDetails.css";
import calender from "../../../../assets/img/calender.png";
import {
  Form,
  Input,
  Option,
  Alert,
  Col,
  Select,
  Spin,
  Row,
  DatePicker,
  Space,
  Button,
} from "antd";
import {
  CloseCircleFilled,
  CheckCircleTwoTone,
  CalendarOutlined,
  LoadingOutlined,
} from "@ant-design/icons";
import { useDispatch, useSelector } from "react-redux";
import history from "../../../../routes/history";
import { getCookie } from "../../../../shared/helpers";
import { fetchToken } from "../../../../API/API";
import axios from "axios";
import moment from "moment";
import {
  getCompanyDetailsSuggestions,
  resetCompanyProfileDetails,
  updateCompanyProfileDetails,
  fetchUserProfile,
  getCompanyProfileDetails,
} from "../../../../redux/actions";

import "../CompanyDetails.css";
import { useLocation } from "react-router-dom";
import RequestDemo from '../../../Signup/Signup-Steps/RequestDemo';

const DetailsForm = (props) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const BackendApiBaseUrl = process.env.REACT_APP_API_URL;
  const [modal2Open, setModal2Open] = useState(false);
  const dropdown = useSelector(
    (state) => state.getCompanyDetailsReducer.dropdown
  );
  const loading = useSelector(
    (state) => state.getCompanyDetailsReducer.loading
  );
  const success = useSelector(
    (state) => state.getCompanyDetailsReducer.success
  );
  const response_ = useSelector(
    (state) => state.getCompanyDetailsReducer.details
  );
  const cpResp = useSelector(
    (state) => state.getCompanyProfileDetailsReducer.resp
  );
  const finishProfile = getCookie("finishProfile");

  let userProfile1 = JSON.parse(localStorage.getItem("userProfile"));
  const [companySizeDropdown, setCompanySizeDropdown] = useState();
  const [companyTypeDropdown, setCompanyTypeDropdown] = useState();
  const [industryDropdown, setIndustryDropdown] = useState();
  const [CompanyName, setCompanyName] = useState("");
  const [IndustryName, setIndustry] = useState("");
  const [CompanyType, setCompanyType] = useState("");
  const [CompanySize, setCompanySize] = useState("");
  const [YearFounded, setYearFounded] = useState(userProfile1.Profiles?.YearFounded
    ? moment(userProfile1.Profiles?.YearFounded).format("YYYY") 
    : cpResp?.companyProfile?.YearFounded
   ? moment(cpResp?.companyProfile?.YearFounded).format("YYYY") 
   : props.state?.YearFounded ?
     moment(props.state?.YearFounded).format("YYYY") 
    : "");

  const [savePressed, setSavePressed] = useState(false);
  const [facultyn, setfacultyn] = useState("");
  const [FacilityOptions, setFacilityOptions] = useState();
  const [placeId, setPlaceId] = useState(null);
  const [jobFacility, setjobFacility] = useState();
  const [dateError, setDateError] = useState(false);
  const token = useSelector((state) => state.authReducer.user.authToken);
  const profile = JSON.parse(localStorage.getItem('userProfile'));
  const { RangePicker } = DatePicker;

  function disabledDate(current) {
    // Disable years from the current year onwards
    return current && current.year() > moment().year();
  }
  useEffect(() => {
    if (profile?.EmpApproved === false && location?.pathname != "/companyprofile/companydetails") {
      setModal2Open(true)
    }else{
      setModal2Open(false)
    }
  }, [profile,profile?.EmpApproved])
  useEffect(() => {
    dispatch(getCompanyDetailsSuggestions());
  }, []);

    useEffect(() => {
      setCompanyName(props.state?.CompanyName);
      setIndustry(
        userProfile1.Profiles?.Industries?.IndustryName
          ? userProfile1.Profiles?.Industries?.IndustryName
          : cpResp?.companyProfile?.Industries?.IndustryName
          ? cpResp?.companyProfile?.Industries?.IndustryName
          : props.state?.IndustryName
      );
      setCompanyType(props.state?.CompanyType);
      setCompanySize(props.state?.CompanySize);
     }, [
      props.state?.CompanyName,
      props.state?.IndustryName,
      props.state?.CompanyType,
      props.state?.CompanySize,
    ]);               

  useEffect(() => {
    if (success && location.state?.previous === "companyprofile") {
      dispatch(fetchUserProfile(token));
      history.push("/companyprofile");
      setTimeout(() => {
        dispatch(resetCompanyProfileDetails());
      }, 2000);
    }
  }, [success]);

  useEffect(() => {
    if (success && !props.state) {
      dispatch(resetCompanyProfileDetails());
      history.push({
        pathname: "/personaldetails",
        state: { fromCompanyDetails: true },
      });
    }
  }, [success]);

  useEffect(() => {
    var options = [];
    if (dropdown && dropdown.company_sizes) {
      for (var i = 0; i < dropdown.company_sizes.length; i++) {
        options = [
          ...options,
          {
            value: dropdown.company_sizes[i].CompanySize,
          },
        ];
      }
      options.sort(
        (a, b) =>
          a.value.split("-")[0].trim().replace(/[+]/g, "") -
          b.value.split("-")[0].trim().replace(/[,+]/g, "")
      );
      setCompanySizeDropdown(options);
    }
  }, [dropdown]);

  const getFacilityName = async (value) => {
    const headers = await fetchToken();
    const response = axios.get(
      `${BackendApiBaseUrl}/empgigs/suggestions?facilityName=${value}`,
      {
        headers,
      }
    );
    setjobFacility((await response).data);
  };

  const changeFacilityHandler = () => {
    setFacilityOptions("");
    setfacultyn("");
  };

  useEffect(() => {
    var options = [];
    if (jobFacility?.length > 0) {
      for (var i = 0; i < jobFacility?.length; i++) {
        options = [
          ...options,
          {
            value: jobFacility[i].description,
            key: i,
            place_id: jobFacility[i].place_id,
          },
        ];
      }
      setFacilityOptions(options);
    }
  }, [jobFacility]);

  useEffect(() => {
    var options = [];
    if (dropdown && dropdown.company_types) {
      for (var i = 0; i < dropdown.company_types.length; i++) {
        options = [
          ...options,
          {
            value: dropdown.company_types[i].CompanyType,
          },
        ];
      }
      const sortedOptions = options.sort(function (a, b) {
        if (a.value < b.value) {
          return -1;
        }
        if (a.value > b.value) {
          return 1;
        }
        return 0;
      });
      setCompanyTypeDropdown(sortedOptions);
    }
  }, [dropdown]);

  useEffect(() => {
    var options = [];
    if (dropdown && dropdown.industries) {
      for (var i = 0; i < dropdown.industries.length; i++) {
        options = [
          ...options,
          {
            value: dropdown.industries[i].IndustryName,
          },
        ];
      }
      const sortedOptions = options.sort(function (a, b) {
        if (a.value < b.value) {
          return -1;
        }
        if (a.value > b.value) {
          return 1;
        }
        return 0;
      });
      setIndustryDropdown(sortedOptions);
    }
  }, [dropdown]);
  
  const onYearFounded = (date, yearString) => {
    if (date !== null) {
    setYearFounded(yearString);
    }
    form.validateFields(['yearFounded']);
    };

    const sendDetails = async () => {
      setSavePressed(true)
      if(props?.profileImageDeleteCheck){
        dispatch(updateCompanyProfileDetails({PictureUrl:null}));
      }
      if(props?.profileImageKey){
        localStorage.setItem('profilePicture',JSON.stringify(props?.profileImageKey))
      }
        if(CompanyName==""|| CompanyName == !props.state?.CompanyName ||
         IndustryName==""|| IndustryName ==!props.state?.IndustryName ||
          CompanyType==""|| CompanyType == !props.state?.CompanyType ||
           CompanySize=="" || CompanySize ==!props.state?.CompanySize || 
           YearFounded=="" || YearFounded == "-1" || YearFounded ==! props.state?.YearFounded){
            
             
        } 
        else {
            dispatch(updateCompanyProfileDetails({
         CompanyName, Industries:{IndustryName:IndustryName}, CompanyType, CompanySize, YearFounded , profileEdit: finishProfile ? true : false, PictureUrl:props.profileImageKey, PlaceId: placeId}));
        }   
    };

    const getCompanyName = (e) => {
        setCompanyName(e.target.value)
    }

  const selectIndustry = (e) => {
    setIndustry(e);
  };

  const getCompanyType = (e) => {
    setCompanyType(e);
  };

  const getCompanySize = (e) => {
    setCompanySize(e);
  };

  const [form] = Form.useForm();
  return (
    <>
      <Col className={"form-div"} lg={24} md={24} sm={24} xs={24}>
        <Form
          form={form}
          onFinish={sendDetails}
          className="details-form"
          initialValues={{
            companyName: userProfile1.Profiles?.CompanyName
              ? userProfile1.Profiles?.CompanyName
              : cpResp?.companyProfile?.CompanyName
              ? cpResp?.companyProfile?.CompanyName
              : props.state?.CompanyName
              ? props.state?.CompanyName
              : "",
            industry: userProfile1.Profiles?.Industries?.IndustryName
              ? userProfile1.Profiles?.Industries?.IndustryName
              : cpResp?.companyProfile?.Industries?.IndustryName
              ? cpResp?.companyProfile?.Industries?.IndustryName
              : props.state?.IndustryName,
             yearFounded: YearFounded,
            companyType: cpResp?.companyProfile?.CompanyType
              ? cpResp?.companyProfile?.CompanyType
              : props.state?.CompanyType,
            companySize: cpResp?.companyProfile?.CompanySize
              ? cpResp?.companyProfile?.CompanySize
              : props.state?.CompanySize,
          }}
        >
          <Col lg={24} md={24} sm={24} xs={24}>
            <strong>
              Company name <a>*</a>
            </strong>
            <Form.Item
              name={"companyName"}
              style={{ width: "100%", marginTop: "2%" }}
              rules={[
                {
                  validator: (_, value) => {
                    if (value.length < 3) {
                      return Promise.reject(new Error("Missing Company Name"));
                    } else if (!value.trim() == "") {
                      return Promise.resolve();
                    } else {
                      return Promise.reject(new Error("Missing Company Name"));
                    }
                  },
                },
              ]}
            >
              <Input
                addonBefore={null}
                addonAfter={null}
                placeholder="Add your company name"
                type={"input"}
                onChange={getCompanyName}
                name={"companyName"}
                className={"form-input"}
                allowClear
              />
            </Form.Item>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <strong>
              Industry <a>*</a>{" "}
            </strong>
            <Row>
              <Col className="input-padding" lg={24} md={24} sm={24} xs={24}>
                <Form.Item
                  name={"industry"}
                  rules={[
                    { required: true, message: "Choose an industry" },
                  ]}
                  style={{ marginTop: "2%" }}
                >
                  <Select
                    className="Selectt"
                    options={industryDropdown}
                    showSearch
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? "")
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? "").toLowerCase())
                    }
                    placeholder="Choose your company’s industry"
                    onChange={selectIndustry}
                    allowClear
                  ></Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <strong>
              Year founded <a>*</a>
            </strong>
            <Form.Item
              style={{ width: "100%", marginTop: "2%" }}
              rules={[
                // { required: true, message: "Year founded is required" },
                {
                  validator: (_, value) => {
                    if (YearFounded > 0) {
                      setDateError(false);
                      return Promise.resolve();
                    } else {
                      setDateError(true);       
                      return Promise.reject(
                        new Error("Year founded is required")
                      );      
                    }                 
                  },
                },
              ]}
              name={"yearFounded"}
            >
          <Row className="calender_container">
          <div className="icon-container">
            <div className="iconCont">
              <img src={calender} alt="calender" />
            </div>
          </div>
          <div className="date-container">
              <DatePicker
                className="dateP"
                value={YearFounded ? moment(YearFounded) : ""}
                suffixIcon={null}
                style={{width: "100%", height: "100%", border:  dateError ? "solid 1px #ff4d4f" : "solid 1px #e4e4e4"}}
                onChange={onYearFounded}
                disabledDate={disabledDate}
                picker="year"
                placeholder="Add your year founded here..."                
                  />
                </div>
                </Row>
            </Form.Item>
          </Col>

          <Col lg={24} md={24} sm={24} xs={24}>
            <strong>
              Company type <a>*</a>{" "}
            </strong>
            <Row>
              <Col className="input-padding" lg={24} md={24} sm={24} xs={24}>
                <Form.Item
                  name={"companyType"}
                  rules={[
                    { required: true, message: "Please Select Company Type" },
                  ]}
                  style={{ marginTop: "2%" }}
                >
                  <Select
                    className="Selectt"
                    options={companyTypeDropdown}
                    showSearch
                    filterSort={(optionA, optionB) =>
                      (optionA?.label ?? "")
                        .toLowerCase()
                        .localeCompare((optionB?.label ?? "").toLowerCase())
                    }
                    placeholder="Add your company type"
                    onChange={getCompanyType}
                    allowClear
                  ></Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            <strong>
              Company size <a>*</a>{" "}
            </strong>
            <Row>
              <Col className="input-padding" lg={24} md={24} sm={24} xs={24}>
                <Form.Item
                  name={"companySize"}
                  rules={[
                    { required: true, message: "Please Select Company Size" },
                  ]}
                  style={{ marginTop: "2%" }}
                >
                  <Select
                    className="Selectt"
                    options={companySizeDropdown}
                    placeholder="Add your company size "
                    onChange={getCompanySize}
                    allowClear
                  ></Select>
                </Form.Item>
              </Col>
            </Row>
          </Col>
          <Col lg={24} md={24} sm={24} xs={24}>
            {/* <hr/> */}
          </Col>
          <div className={"form-submit-btn-container"}>
            <Button
              htmlType={"submit"}
              className="form-save-btn"
            >
              {(savePressed && loading) || props?.imageLoading ? (
                <LoadingOutlined />
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </Form>
        <RequestDemo modal2Open={modal2Open} />
      </Col>
    </>
  );
};

export default DetailsForm;